import animData from "../../artConfig.json";
let anim: Phaser.Animations.Animation | undefined;
let anim2: Phaser.Animations.Animation | undefined;
let anim3: Phaser.Animations.Animation | undefined;
let anim4: Phaser.Animations.Animation | undefined;

class Star1 extends Phaser.GameObjects.Particles.Particle {
  public t: number;
  public i: number;
  constructor(emitter: Phaser.GameObjects.Particles.ParticleEmitter) {
    super(emitter);
    this.i = Math.floor(Math.random() * 16);
    this.t = 0;
  }

  update(delta: number, step: number, processors: any[]) {
    const result = super.update(delta, step, processors);
    this.t += delta;

    if (!anim) {
      throw new Error("animation not found...");
      return result;
    }

    if (this.t >= anim.msPerFrame) {
      this.i++;

      if (this.i > 6) {
        this.i = 0;
      }

      this.frame = anim.frames[this.i].frame;

      this.t -= anim.msPerFrame;
    }

    return result;
  }
}
class Star2 extends Phaser.GameObjects.Particles.Particle {
  public t: number;
  public i: number;
  constructor(emitter: Phaser.GameObjects.Particles.ParticleEmitter) {
    super(emitter);
    this.i = Math.floor(Math.random() * 16);
    this.t = 0;
  }

  update(delta: number, step: number, processors: any[]) {
    const result = super.update(delta, step, processors);
    this.t += delta;

    if (!anim2) {
      throw new Error("animation not found...");
      return result;
    }

    if (this.t >= anim2.msPerFrame) {
      this.i++;

      if (this.i > 6) {
        this.i = 0;
      }

      this.frame = anim2.frames[this.i].frame;

      this.t -= anim2.msPerFrame;
    }

    return result;
  }
}
class Star3 extends Phaser.GameObjects.Particles.Particle {
  public t: number;
  public i: number;
  constructor(emitter: Phaser.GameObjects.Particles.ParticleEmitter) {
    super(emitter);
    this.i = Math.floor(Math.random() * 16);
    this.t = 0;
  }

  update(delta: number, step: number, processors: any[]) {
    const result = super.update(delta, step, processors);
    this.t += delta;

    if (!anim3) {
      throw new Error("animation not found...");
      return result;
    }

    if (this.t >= anim3.msPerFrame) {
      this.i++;

      if (this.i > 6) {
        this.i = 0;
      }

      this.frame = anim3.frames[this.i].frame;

      this.t -= anim3.msPerFrame;
    }

    return result;
  }
}
class Star4 extends Phaser.GameObjects.Particles.Particle {
  public t: number;
  public i: number;
  constructor(emitter: Phaser.GameObjects.Particles.ParticleEmitter) {
    super(emitter);
    this.i = Math.floor(Math.random() * 16);
    this.t = 0;
  }

  update(delta: number, step: number, processors: any[]) {
    const result = super.update(delta, step, processors);
    this.t += delta;

    if (!anim4) {
      throw new Error("animation not found...");
      return result;
    }

    if (this.t >= anim4.msPerFrame) {
      this.i++;

      if (this.i > 6) {
        this.i = 0;
      }

      this.frame = anim4.frames[this.i].frame;

      this.t -= anim4.msPerFrame;
    }

    return result;
  }
}

export class StarParticles {
  constructor(scene: Phaser.Scene) {
    anim = scene.game.anims.get(animData.animations.star1.key);
    anim2 = scene.game.anims.get(animData.animations.star2.key);
    anim3 = scene.game.anims.get(animData.animations.star3.key);
    anim4 = scene.game.anims.get(animData.animations.star4.key);
    const particles = scene.add.particles("atlas");
    particles.setDepth(-3);

    const rect = new Phaser.Geom.Rectangle(-1, -1, 128 + 1, 65);

    const emitter = particles.createEmitter({
      quantity: { min: 1, max: 2 },
      frame: "FX/stars/star1_1",
      frequency: 7300,
      maxVelocityX: 0,
      maxVelocityY: 0,
      speed: 0,
      gravityY: 0,
      lifespan: 14000,
      particleClass: Star1 as any,
      emitZone: { type: "random", source: rect },
    });
    const emitter4 = particles.createEmitter({
      quantity: { min: 2, max: 4 },
      frame: "FX/stars/star1_1",
      frequency: 9300,
      maxVelocityX: 0,
      maxVelocityY: 0,
      speed: 0,
      gravityY: 0,
      lifespan: 20000,
      particleClass: Star4 as any,
      emitZone: { type: "random", source: rect },
    });
    const emitter2 = particles.createEmitter({
      quantity: { min: 1, max: 2 },
      frame: "FX/stars/star2_1",
      frequency: 8100,
      maxVelocityX: 0,
      maxVelocityY: 0,
      speed: 0,
      gravityY: 0,
      lifespan: 14000,
      delay: 3000,
      particleClass: Star2 as any,
      emitZone: { type: "random", source: rect },
    });
    const emitter3 = particles.createEmitter({
      quantity: { min: 0, max: 1 },
      frame: "FX/stars/star3_1",
      frequency: 19000,
      maxVelocityX: 0,
      maxVelocityY: 0,
      speed: 0,
      gravityY: 0,
      lifespan: 14000,
      particleClass: Star3 as any,
      emitZone: { type: "random", source: rect },
    });

    emitter.setAlpha(function (
      p: Phaser.GameObjects.Particles.Particle,
      _k: number,
      t: number
    ) {
      return 1 - 2 * Math.abs(t - 0.5);
    });
    emitter2.setAlpha(function (
      p: Phaser.GameObjects.Particles.Particle,
      _k: number,
      t: number
    ) {
      return 1 - 2 * Math.abs(t - 0.5);
    });
    emitter3.setAlpha(function (
      p: Phaser.GameObjects.Particles.Particle,
      _k: number,
      t: number
    ) {
      return 1 - 2 * Math.abs(t - 0.5);
    });
    emitter4.setAlpha(function (
      p: Phaser.GameObjects.Particles.Particle,
      _k: number,
      t: number
    ) {
      return 1 - 2 * Math.abs(t - 0.5);
    });
  }
}
